import IdentitiesItem     from '../Collections/IdentitiesItem.js';
import CollectionList     from '@/js/Shared/Collections/CollectionList.js';
import AccountController  from '@/js/Webmail/AccountController.js';

export { IdentitiesHTTPMapping as default };

/**
* Identities HTTP Mapping
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class IdentitiesHTTPMapping {
  /**
   * Maps Identities Server Response to an Identities Collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {CollectionList} identities identities collection
   * @param {Array}          results    http response entity
   *
   * @return {void}
   */
  map(identities, results) {
    if (!results) {
      return identities;
    }

    identities.reset();
    this.mapItems(identities, results);
  }

  /**
   * Maps Identities Items to the Ientities collection
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {CollectionList} identities identities collection
   * @param {Object}         data      server data
   *
   * @return {void}
   */
  mapItems(identities, data) {
    data.forEach((item, index) => {
      let entity            = new IdentitiesItem();
      entity.id             = item.id;
      entity.index          = index;
      entity.name           = item.fullname;
      entity.bccs           = item.bcc_addr || [];
      entity.email          = item.from_addr || null;
      entity.signature_html = item.signature_html || null;
      entity.default        = item.default;
      entity.is_alias       = AccountController.isAlias(entity.email);
      identities.add(entity)

      if (entity.default) {
        identities.default = entity.index;
      }
    });
  }
}